import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { examRoomRouteRef, rootRouteRef } from './routes';

export const devClinicPlugin = createPlugin({
  id: 'devClinic',
  routes: {
    root: rootRouteRef,
    room: examRoomRouteRef,
  },
});

export const DevClinicPage = devClinicPlugin.provide(
  createRoutableExtension({
    name: 'DevClinicPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
